import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "excel-icon",
  "use": "excel-icon-usage",
  "viewBox": "0 0 83.3 102.9",
  "content": "<symbol viewBox=\"0 0 83.3 102.9\" id=\"excel-icon\"><path fill=\"#1f7447\" d=\"M55.4 34.1V17.7H16.6v75.1h52V34.1z\" /><path fill=\"#529943\" d=\"M68.6 34.1L55.4 17.7v16.4z\" /><path d=\"M44.7 46.8h2.5l-3.5 5.4c-.4.6-.7 1.2-.7 1.1h-.1c0-.1-.1-.2-.2-.3-.1-.2-.3-.5-.6-.8l-3.6-5.4h2.6v-3.6h-9.8v3.6h2.3L40 56l-6.6 9.6h-2.3v3.6h9.5v-3.6h-2.5l3.5-5.5c.4-.6.6-1.2.7-1.2h.1c0 .1.1.2.2.3.1.3.3.5.6.8l3.6 5.5h-2.6v3.6h9.9v-3.6h-2.3l-6.5-9.3 6.6-9.6h2.3V43h-9.5v3.8z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/excel-icon.svg
// module id = g+ba
// module chunks = 1